/* Bibi Abaya: instant filtering + sorting for collection and search pages */
(function () {
  var root = document.querySelector('[data-bb-listing]');
  if (!root) return;
  var grid = root.querySelector('.bb-grid');
  var side = document.getElementById('bb-side');
  if (!grid || !side) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.bb-cardwrap'));
  var countEl = root.querySelector('[data-count]');
  var emptyEl = root.querySelector('[data-empty]');
  var activeEl = root.querySelector('[data-active]');
  var sortEl = root.querySelector('[data-sort]');
  var clearBtn = side.querySelector('[data-clear]');
  var minEl = side.querySelector('[data-price-min]');
  var maxEl = side.querySelector('[data-price-max]');
  var HEX = { black: '#0e0e0e', cream: '#efe3cf', champagne: '#e3cfae', sand: '#d8c7a9', oat: '#d9cdb8', pink: '#e9a9c6', blush: '#e8c3bd', rose: '#d99aa5', rosewood: '#9a5a5f', mauve: '#8c6f80', 'grey mauve': '#8d7f86', lilac: '#b9a4c9', plum: '#5b2c4d', aubergine: '#3d2238', wine: '#5a0a12', burgundy: '#6b1620', 'steel blue': '#5f7e95', slate: '#5d6872', midnight: '#1b2a49', teal: '#2f7f84', sage: '#9ba88a', grey: '#808080', taupe: '#8f7f73', mushroom: '#a89a8c', mocha: '#7a5a46', chestnut: '#7b4a30', chocolate: '#4a2e22', espresso: '#2f211b', white: '#ffffff', brown: '#5a3d2b', beige: '#d9c7a8' };
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  var list = function (s) { return (s || '').split('|').filter(Boolean); };
  cards.forEach(function (c, i) {
    var d = c.dataset;
    c._f = { colors: list(d.colors), sizes: list(d.sizes), dupatta: list(d.dupatta), price: Number(d.price) / 100, available: d.available === 'true', sale: d.sale === 'true', isNew: d.new === 'true', best: d.best === 'true', title: d.title || '', order: i };
  });

  // build facet options from what is actually on the page
  function uniq(key) {
    var seen = {}, out = [];
    cards.forEach(function (c) { c._f[key].forEach(function (v) { if (!seen[v]) { seen[v] = 0; out.push(v); } seen[v]++; }); });
    return { values: out, counts: seen };
  }
  var state = { colors: [], sizes: [], dupatta: [], min: null, max: null, available: false, sale: false, isNew: false, best: false };

  function build(name, key, render) {
    var wrap = side.querySelector('[data-facet-wrap="' + name + '"]');
    var host = side.querySelector('[data-facet="' + name + '"]');
    var u = uniq(key);
    if (!wrap || !u.values.length) return;
    if (name === 'size') u.values.sort(function (a, b) { var n = parseFloat(a), m = parseFloat(b); if (!isNaN(n) && !isNaN(m)) return n - m; var x = SIZE_ORDER.indexOf(a), y = SIZE_ORDER.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); });
    host.innerHTML = u.values.map(function (v) { return render(v, u.counts[v]); }).join('');
    wrap.hidden = false;
  }
  var esc = function (s) { return String(s).replace(/"/g, '&quot;'); };
  build('colour', 'colors', function (v) {
    var hex = HEX[v.toLowerCase()] || '#cccccc';
    return '<label class="bb-side__sw" title="' + esc(v) + '"><input type="checkbox" data-key="colors" value="' + esc(v) + '"><span style="--sw:' + hex + '"></span><em>' + v + '</em></label>';
  });
  build('size', 'sizes', function (v) { return '<label class="bb-side__chip"><input type="checkbox" data-key="sizes" value="' + esc(v) + '"><span>' + v + '</span></label>'; });
  build('dupatta', 'dupatta', function (v, n) { return '<li><label><input type="checkbox" data-key="dupatta" value="' + esc(v) + '"><i></i><span>' + v + '</span><small>' + n + '</small></label></li>'; });

  function matches(f) {
    if (state.colors.length && !state.colors.some(function (v) { return f.colors.indexOf(v) > -1; })) return false;
    if (state.sizes.length && !state.sizes.some(function (v) { return f.sizes.indexOf(v) > -1; })) return false;
    if (state.dupatta.length && !state.dupatta.some(function (v) { return f.dupatta.indexOf(v) > -1; })) return false;
    if (state.min !== null && f.price < state.min) return false;
    if (state.max !== null && f.price > state.max) return false;
    if (state.available && !f.available) return false;
    if (state.sale && !f.sale) return false;
    if (state.isNew && !f.isNew) return false;
    if (state.best && !f.best) return false;
    return true;
  }
  function chips() {
    var out = [];
    ['colors', 'sizes', 'dupatta'].forEach(function (k) { state[k].forEach(function (v) { out.push({ k: k, v: v, label: v }); }); });
    if (state.min !== null || state.max !== null) out.push({ k: 'price', label: '₹' + (state.min || 0) + ' - ' + (state.max === null ? 'any' : state.max) });
    [['available', 'In stock'], ['sale', 'On sale'], ['isNew', 'New arrivals'], ['best', 'Best sellers']].forEach(function (p) { if (state[p[0]]) out.push({ k: p[0], label: p[1] }); });
    return out;
  }
  function apply() {
    var shown = 0;
    cards.forEach(function (c) { var ok = matches(c._f); c.hidden = !ok; if (ok) shown++; });
    if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
    if (emptyEl) emptyEl.hidden = shown !== 0;
    grid.hidden = shown === 0;
    var cs = chips();
    if (activeEl) {
      activeEl.hidden = !cs.length;
      activeEl.innerHTML = cs.map(function (c) { return '<button type="button" data-rm="' + c.k + '" data-v="' + esc(c.v || '') + '">' + c.label + ' <span>&times;</span></button>'; }).join('');
    }
    if (clearBtn) clearBtn.hidden = !cs.length;
  }
  function sync() { // reflect state in the sidebar controls
    side.querySelectorAll('input[data-key]').forEach(function (i) { i.checked = state[i.dataset.key].indexOf(i.value) > -1; });
    side.querySelectorAll('input[data-flag]').forEach(function (i) { i.checked = !!state[i.dataset.flag === 'new' ? 'isNew' : i.dataset.flag]; });
    minEl.value = state.min === null ? '' : state.min;
    maxEl.value = state.max === null ? '' : state.max;
  }
  function reset() { state = { colors: [], sizes: [], dupatta: [], min: null, max: null, available: false, sale: false, isNew: false, best: false }; sync(); apply(); }

  side.addEventListener('change', function (e) {
    var t = e.target;
    if (t.dataset.key) {
      var arr = state[t.dataset.key], i = arr.indexOf(t.value);
      if (t.checked && i < 0) arr.push(t.value);
      if (!t.checked && i > -1) arr.splice(i, 1);
    } else if (t.dataset.flag) {
      state[t.dataset.flag === 'new' ? 'isNew' : t.dataset.flag] = t.checked;
    }
    apply();
  });
  var pt;
  function price() { clearTimeout(pt); pt = setTimeout(function () { state.min = minEl.value === '' ? null : Number(minEl.value); state.max = maxEl.value === '' ? null : Number(maxEl.value); apply(); }, 250); }
  minEl.addEventListener('input', price); maxEl.addEventListener('input', price);
  if (clearBtn) clearBtn.addEventListener('click', reset);
  root.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]');
    if (rm) {
      var k = rm.dataset.rm, v = rm.dataset.v;
      if (k === 'price') { state.min = null; state.max = null; }
      else if (Array.isArray(state[k])) state[k] = state[k].filter(function (x) { return x !== v; });
      else state[k] = false;
      sync(); apply();
    }
    if (e.target.closest('[data-reset]')) reset();
  });

  // sorting (client side)
  var sorters = {
    featured: function (a, b) { return a._f.order - b._f.order; },
    'price-asc': function (a, b) { return a._f.price - b._f.price || a._f.order - b._f.order; },
    'price-desc': function (a, b) { return b._f.price - a._f.price || a._f.order - b._f.order; },
    'title-asc': function (a, b) { return a._f.title < b._f.title ? -1 : 1; },
    'title-desc': function (a, b) { return a._f.title < b._f.title ? 1 : -1; }
  };
  if (sortEl) sortEl.addEventListener('change', function () {
    cards.slice().sort(sorters[sortEl.value] || sorters.featured).forEach(function (c) { grid.appendChild(c); });
  });

  // mobile drawer
  var scrim = document.querySelector('.bb-side__scrim');
  function drawer(on) { side.classList.toggle('is-open', on); if (scrim) scrim.classList.toggle('is-open', on); document.documentElement.classList.toggle('bb-locked', on); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bb-side-open]')) drawer(true);
    if (e.target.closest('[data-bb-side-close]')) drawer(false);
  });
  apply();
})();
